/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

/**
 * @module bulb-image/bulb-imagerotate/bulbimagerotatecommand
 */

import {
  Command, ModelElement, type ModelWriter, ModelPosition,
} from 'ckeditor5';

/**
 * The bulb image rotate command, the actual modification capabilities of the plugin.
 *
 * @extends Command
 */
export class BulbImageCropCommand extends Command {
  // TODO TAM clean: This implementation isn't clean, definitely needs refactored.
  /**
   * @inheritDoc
   * When the command is executed, we need to initialize the cropper inside of the editor.
   *
   * @param croppedImage The cropped image.
   * @param blockId blockId of the current content block.
   */
  public override execute(croppedImage: any, blockId: string): void {
    this.editor.model.change((writer: ModelWriter) => {
      const blockToCrop = this.editor.model.document.selection.getSelectedElement() as ModelElement;
      writer.setAttribute('src', croppedImage.url, blockToCrop);
      writer.setAttribute('bulb-block-version', croppedImage.version, blockToCrop);
    });
  }

  /**
   * @inheritDoc
   */
  public override refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition() as ModelPosition, 'image');
    this.set('isEnabled', allowedIn !== null);
  }

}
